export const isIosOrAndroidWithShare = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (/Android/i.test(userAgent)) return !!navigator.share;
  if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) return !!navigator.share;
  return false;
};
